import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { CharterDAO } from '../../../../core/services/dao/charterDAO';
import { CaptainDAO } from '../../../../core/services/dao/captainDAO';
import { VesselDAO } from '../../../../core/services/dao/vesselDAO';
import { CrewMemberDAO } from '../../../../core/services/dao/crewMemberDAO';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { environment } from '../../../../environments/environment';

@Injectable()
export class EditCharterResolve implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private charterDao: CharterDAO,
    private captainDao: CaptainDAO,
    private boatDao: VesselDAO,
    private crewMemberDao: CrewMemberDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const id = route.params.id;
    const charterResolve = this.charterDao.loadById(id);
    const sessionResolve = this.authService.checkSession();
    const captainResolve = this.captainDao.adminActiveCaptainList();
    const boatResolve = this.boatDao.loadForCharterPages();
    const crewMemberResolve = this.crewMemberDao.load();
    const vesselResolve = this.boatDao.loadByCharterId(id);
    return combineLatest([
      charterResolve,
      sessionResolve,
      captainResolve,
      boatResolve,
      crewMemberResolve,
      vesselResolve,
    ]).pipe(
      map(
        ([
          charterResolve,
          sessionResolve,
          captainResolve,
          boatResolve,
          crewMemberResolve,
          vesselResolve,
        ]) => ({
          charterResolve,
          sessionResolve,
          captainResolve,
          boatResolve,
          crewMemberResolve,
          vesselResolve,
        }),
      ),
      take(1),
    );
  }
}
